import { render, staticRenderFns } from "./candidateEducation.vue?vue&type=template&id=a2488a18&"
import script from "./candidateEducation.vue?vue&type=script&lang=js&"
export * from "./candidateEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports